import { render, staticRenderFns } from "./EditInstitution.vue?vue&type=template&id=7012f925"
import script from "./EditInstitution.vue?vue&type=script&lang=js"
export * from "./EditInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports